import React, { useState } from 'react';
import useMeasure from 'react-use-measure';
import { animated, useSpring } from 'react-spring';
import classNames from 'classnames';
import styles from './index.module.scss';

export default function CollapseBase({ children, title }) {
  const [isOpened, setIsOpened] = useState(true);
  const [contentRef, { height }] = useMeasure();
  const [styleHeight, apiHeight] = useSpring(() => ({
    height: 0,
    overflow: 'hidden',
    duration: 100,
  }));
  apiHeight.start({
    height: isOpened ? height : 0,
  });
  const [styleAnimate, api] = useSpring(() => ({
    transform: 'rotate(0deg)',
    duration: 300,
  }));
  api.start({ transform: isOpened ? 'rotate(180deg)' : 'rotate(0deg)' });
  return (
    <div className={styles.collapse}>
      <div
        onClick={() => setIsOpened(!isOpened)}
        className={classNames('flex-row-nowrap', 'flex-between-center', styles.collapseHeader)}
      >
        <div className={styles.collapseTitle}>{title}</div>
        <animated.div style={styleAnimate}>
          <div className={styles.collapseArrows}>
            <svg className="icon" aria-hidden="true">
              <use xlinkHref="#icon-keyboard_arrow_down"></use>
            </svg>
          </div>
        </animated.div>
      </div>
      <animated.div style={styleHeight}>
        <div ref={contentRef}>{children}</div>
      </animated.div>
    </div>
  );
}
